import { createContext, Dispatch, SetStateAction, useContext } from 'react'

export interface ISalaryStatuses {
  isConfirm: boolean
  isPreview: boolean
}

export interface ISalaryStatusesContext {
  salaryStatuses: ISalaryStatuses
  setSalaryStatuses: Dispatch<SetStateAction<ISalaryStatuses>>
}

export interface ISalaryStatusesWithConfirmContext extends ISalaryStatusesContext {
  isConfirm: boolean
}

export const SalaryStatusesContext = createContext<ISalaryStatusesContext>(
  {} as ISalaryStatusesContext,
)
export const useSalaryStatusesContext = (): ISalaryStatusesWithConfirmContext => {
  const { salaryStatuses, setSalaryStatuses } = useContext(SalaryStatusesContext)
  return {
    salaryStatuses,
    setSalaryStatuses,
    isConfirm: salaryStatuses.isConfirm || !salaryStatuses.isPreview,
  }
}
